import { graphql } from 'react-relay';

import { SchoolExamProblemWindowPaginator_query$key } from '../../../relay/__generated__/SchoolExamProblemWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const SchoolExamProblemWindowPaginator_query = graphql`
  fragment SchoolExamProblemWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: SchoolExamProblemFilter }
    order: { type: SchoolExamProblemOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int, defaultValue: 20 }
  )
  @refetchable(queryName: "SchoolExamProblemWindowPaginatorRefreshQuery") {
    schoolExamProblems(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...SchoolExamProblemConnectionDataTable_schoolExamProblemConnection
    }
  }
`;

type Props = Omit<FragmentWindowPaginatorProps<SchoolExamProblemWindowPaginator_query$key>, 'fragment'>;

const SchoolExamProblemWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={SchoolExamProblemWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (props) => (
          <Pagination {...props} pages={data.schoolExamProblems.pages} loadPage={loadPage} />
        ),
      })
    }
  </FragmentWindowPaginator>
);

export default SchoolExamProblemWindowPaginator;
